import { Fragment, useEffect, useRef, useState } from "react";
import StyleChanger from "./StyleChanger";
import { mapTilerKey } from "./Constants";
import { v4 as uuidv4 } from 'uuid';
import axios from "axios";
import { geojsonSource } from "./sources/Sources";
import { polygonLayer, polygonLayer3D } from "./layers/PolygonLayer";
import { lineLayer } from "./layers/LineLayer";
import { turkeyParks, turkeyWaterSources, istanbulDistricts, istanbulParkPoints, istanbulParkPolygon } from "../data/turkeyData";
import { turkeyPopulationData, turkeyPopulation3DData, turkeyRiversData } from "../data/populationData";
import { fetchIstanbulParks, fetchMunicipalityData, fetchRealRiversData } from "../services/dataService";
// ABB park verilerini import et (build zamanında bundle'a dahil olacak)
import abbParkData from '../data/abbData.json';
import ExamplesMenu from "./ExamplesMenu";
import RegionalSearch from "./RegionalSearch";
import LayerControls from "./LayerControls";
import ImageOverlay from "./ImageOverlay";
import { useNavigate } from 'react-router-dom';

// CDN'den yüklenecek maplibre-gl'i kullan
const maplibregl = window.maplibregl;

const Map = () => {
  
  const map = useRef(null);
  const [activeExample, setActiveExample] = useState("all-examples");
  const [activeRegion, setActiveRegion] = useState(null);
  const [isGisMenuOpen, setIsGisMenuOpen] = useState(false);
  const [isRegionalMenuOpen, setIsRegionalMenuOpen] = useState(false);
  const [showLabels, setShowLabels] = useState(true); // İsimleri göster/gizle
  const [showShapes, setShowShapes] = useState(true); // Şekilleri göster/gizle
  const navigate = useNavigate();
  
  useEffect(() => {
    console.log("🚀 Map useEffect başladı");
    console.log("📍 API Key:", mapTilerKey ? "✅ Tanımlı" : "❌ Tanımlı değil");
    
    try {
      console.log("🗺️  MapLibre GL yükleniyor...");
      map.current = new maplibregl.Map({
        container: "map",
        style: "https://api.maptiler.com/maps/basic-v2/style.json?key=" + mapTilerKey, // stylesheet location
        center: [34, 40], // starting position [lng, lat]
        zoom: 6, // starting zoom
        pitch: 0, // 3D görünüm için eğim
        bearing: 0, // Yön
        antialias: true, // Daha yumuşak çizgiler
        attributionControl: false, // Attribution'ı manuel ekleyeceğiz
        logoPosition: 'bottom-right', // Logo konumu
        preserveDrawingBuffer: true, // Canvas'ı koru - şekil tutarlılığı için
        fadeDuration: 0 // Fade animasyonunu kapat
      });
      console.log("✅ Map başarıyla oluşturuldu");
    } catch (error) {
      console.error("❌ Map oluşturulurken hata:", error);
      return;
    }
    
    map.current.on("load", function () {
      console.log("✅ Harita yüklendi! Kontroller ekleniyor...");
      /*addGeojsonSource("https://raw.githubusercontent.com/utahemre/maplibre-gl-example-project/master/public/testdata/population.geojson",
        addPolygonLayer, {'fill-color' : 'red', 'fill-opacity' : 0.5, 'fill-outline-color' : 'white'}
      );*/
      /*addGeojsonSource("https://raw.githubusercontent.com/utahemre/maplibre-gl-example-project/master/public/testdata/population.geojson",
        addPolygonLayer, {'fill-color':
        [
            'step',
            ['get', 'population'],
            '#00FF00',
            500000,
            '#FFFF00',
            1000000,
            '#FFA500',
            3000000,
            '#FF0000',
            50000000,
            '#8B0000'
        ], 'fill-opacity' : 0.5, 'fill-outline-color' : 'black'}
      );*/
      /*addGeojsonSource("https://raw.githubusercontent.com/utahemre/maplibre-gl-example-project/master/public/testdata/population.geojson",
      addPolygonLayer3D, {'fill-extrusion-color' : 'white', 'fill-extrusion-opacity' : 0.8, 'fill-extrusion-height': ["/",["get", "population"], 50]}*/

      /*addGeojsonSource("https://raw.githubusercontent.com/utahemre/maplibre-gl-example-project/master/public/testdata/population.geojson",
      addPolygonLayer3D, {'fill-extrusion-color' : [
        'step',
        ['get', 'population'],
        '#00FF00',
        500000,
        '#FFFF00',
        1000000,
        '#FFA500',
        3000000,
        '#FF0000',
        50000000,
        '#8B0000'
    ], 'fill-extrusion-opacity' : 0.8, 'fill-extrusion-height': ["/",["get", "population"], 50]}
 );*/

 /*addGeojsonSource("https://raw.githubusercontent.com/utahemre/maplibre-gl-example-project/master/public/testdata/rivers.geojson",
      addLineLayer, {'line-color' : 'blue', 'line-opacity' : 0.8, 'line-width' : 2}); */


      // Nehir verileri - sadece buton ile yüklenecek
      // addGeojsonSource("https://raw.githubusercontent.com/utahemre/maplibre-gl-example-project/master/public/testdata/rivers.geojson",
      // addLineLayer, {
      //   'line-color' : [
      //     'match',
      //     ['get', 'featureclass'],
      //     "River", "blue",
      //     "Lake Centerline", "red",
      //     "black"
      //   ], 
      //   'line-opacity' : 0.8, 
      //   'line-width' : ['get', 'scalerank']});  

      // Veriler sadece butonlara basıldığında yüklenecek

      // Tüm veriler sadece butonlara basıldığında yüklenecek

      // Harita kontrollerini ekle - sadece bir kez eklemek için kontrol et
      if (!document.querySelector('.maplibregl-ctrl-group')) {
        map.current.addControl(new maplibregl.NavigationControl(), 'top-left');
      }
      if (!document.querySelector('.maplibregl-ctrl-fullscreen')) {
        map.current.addControl(new maplibregl.FullscreenControl(), 'top-right');
      }
      if (!document.querySelector('.maplibregl-ctrl-scale')) {
        map.current.addControl(new maplibregl.ScaleControl({
          maxWidth: 100,
          unit: 'metric'
        }), 'bottom-left');
      }

      // Custom attribution ekle
      if (!document.querySelector('.maplibregl-ctrl-attrib')) {
        const customAttribution = new maplibregl.AttributionControl({
          customAttribution: '© Pronuve'
        });
        map.current.addControl(customAttribution, 'bottom-right');
      }

      // Popup ekleme
      addPopups();

      // İlk görünürlük durumlarını uygula
      applyLabelsVisibility(showLabels);
      applyShapesVisibility(showShapes);
      });
    
    // Error listener ekle
    map.current.on("error", (error) => {
      console.error("❌ Harita hatası:", error);
    });
    
    map.current.on("style.load", () => {
      console.log("✅ Stil yüklendi");
    });
    
    map.current.on("data", (e) => {
      if (e.dataType === 'style') {
        console.log("✅ Stil verisi yüklendi");
      }
    });

  }, []);

  // Label görünürlüğünü uygula
  const applyLabelsVisibility = (visible) => {
    if (!map.current) return;
    const style = map.current.getStyle();
    if (!style || !style.layers) return;
    style.layers.forEach(layer => {
      const isLabel = layer.id && layer.id.endsWith('-text');
      if (isLabel) {
        try {
          map.current.setLayoutProperty(layer.id, 'visibility', visible ? 'visible' : 'none');
        } catch (_) {}
      }
    });
  };

  // Şekil görünürlüğünü uygula (fill, fill-extrusion, line, circle)
  const applyShapesVisibility = (visible) => {
    if (!map.current) return;
    const style = map.current.getStyle();
    if (!style || !style.layers) return;
    style.layers.forEach(layer => {
      const isOurLayer = layer.id && (
        layer.id.endsWith('-layer') ||
        layer.id.endsWith('-outline') ||
        layer.id.includes('population') ||
        layer.id.includes('parks') ||
        layer.id.includes('park') ||
        layer.id.includes('rivers') ||
        layer.id.includes('district')
      );
      const isShapeType = ['fill', 'fill-extrusion', 'line', 'circle'].includes(layer.type);
      if (isOurLayer && isShapeType && !layer.id.endsWith('-text')) {
        try {
          map.current.setLayoutProperty(layer.id, 'visibility', visible ? 'visible' : 'none');
        } catch (_) {}
      }
    });
  };

  // Label toggle handler
  const onToggleLabels = () => {
    const next = !showLabels;
    setShowLabels(next);
    applyLabelsVisibility(next);
  };

  // Shape toggle handler
  const onToggleShapes = () => {
    const next = !showShapes;
    setShowShapes(next);
    applyShapesVisibility(next);
  };

  const changeStyleHandler = async (styleAddress) => {
    map.current.setStyle(styleAddress);
    
    // Stil değiştikten sonra aktif örneği yeniden yükle
    map.current.once('styledata', async () => {
      if (map.current.isStyleLoaded()) {
        await loadExampleData(activeExample);
      }
    });
  }

  const handleExampleSelect = async (exampleId) => {
    setActiveExample(exampleId);
    await loadExampleData(exampleId);
  }

  const loadExampleData = async (exampleId) => {
    if (!map.current) return;

    // Önceki layer'ları temizle
    clearAllLayers();

    switch (exampleId) {
      case "population-2d":
        loadPopulation2D();
        break;
      case "population-3d":
        loadPopulation3D();
        break;
      case "rivers":
        await loadRivers();
        break;
      case "parks-polygon":
        loadParksPolygon();
        break;
      case "parks-3d":
        loadParks3D();
        break;
      case "istanbul-parks-2d":
        await loadIstanbulParks2D();
        break;
      case "istanbul-parks-3d":
        await loadIstanbulParks3D();
        break;
      case "ankara-parks-2d":
        await loadAnkaraParks2D();
        break;
      case "ankara-parks-3d":
        await loadAnkaraParks3D();
        break;
      case "abb-parks-2d":
        await loadABBParks2D();
        break;
      case "abb-parks-3d":
        await loadABBParks3D();
        break;
      case "ankara-parks-3d-short":
        await loadAnkaraParks3DShort();
        break;
      default:
        // Varsayılan olarak hiçbir şey yükleme
        break;
    }
  }

  const clearAllLayers = () => {
    if (!map.current) return;
    
    // Sadece bizim eklediğimiz custom layer'ları kaldır
    const layers = map.current.getStyle().layers;
    layers.forEach(layer => {
      // UUID ile oluşturulan layer'ları ve belirli pattern'leri kaldır
      if (layer.id.includes('-layer') || 
          layer.id.includes('-text') ||
          layer.id.includes('rivers') ||
          layer.id.includes('population') ||
          layer.id.includes('park') ||
          layer.id.includes('water') ||
          layer.id.includes('district') ||
          // UUID pattern (8-4-4-4-12 format)
          /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(layer.id)) {
        if (map.current.getLayer(layer.id)) {
          map.current.removeLayer(layer.id);
        }
      }
    });

    // Sadece bizim eklediğimiz custom source'ları kaldır
    const sources = map.current.getStyle().sources;
    Object.keys(sources).forEach(sourceId => {
      // UUID ile oluşturulan source'ları ve belirli pattern'leri kaldır
      if (sourceId.includes('-') ||
          sourceId.includes('rivers') ||
          sourceId.includes('population') ||
          sourceId.includes('park') ||
          sourceId.includes('water') ||
          sourceId.includes('district') ||
          // UUID pattern (8-4-4-4-12 format)
          /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(sourceId)) {
        if (map.current.getSource(sourceId)) {
          map.current.removeSource(sourceId);
        }
      }
    });
  }

  const addGeojsonSource = (_url, _callback, _callbackParameters) => {
    axios
      .get(
        _url
      )
      .then((response) => {
        const sourceInstance = geojsonSource(response.data);
        let sourceId = uuidv4();
        map.current.addSource(sourceId,sourceInstance);
        if(_callback){
          _callback(sourceId, _callbackParameters);
        }
        return sourceId; 
    });
  };


  const addLineLayer = (_sourceId, _layerProperties) => {
    const lineLayerInstance = lineLayer(_sourceId, _layerProperties);
    map.current.addLayer(lineLayerInstance);
  };

  const addLocalData = (data, layerType, styleProperties) => {
    console.log('addLocalData called with layerType:', layerType);
    const sourceId = uuidv4();
    const sourceInstance = geojsonSource(data);
    
    // GeoJSON source'u tolerance: 0 ile ekle - simplification'ı tamamen kapat
    map.current.addSource(sourceId, {
      ...sourceInstance,
      tolerance: 0  // Vertex simplification'ı devre dışı bırak
    });
    
    if (layerType === "park-points" || layerType === "other-parks" || layerType === "water" || layerType === "population-2d") {
      // Circle layer for points
      console.log('Adding circle layer');
      map.current.addLayer({
        id: sourceId + "-layer",
        type: "circle",
        source: sourceId,
        paint: styleProperties
      });
    } else if (layerType === "park-polygon" || layerType === "districts" || layerType === "parks-polygon") {
      // Fill layer for polygons
      console.log('Adding fill layer for parks-polygon');
      
      map.current.addLayer({
        id: sourceId + "-layer",
        type: "fill",
        source: sourceId,
        paint: {
          ...styleProperties,
          'fill-antialias': false  // Şekil değişimlerini önlemek için
        }
      });
      
      // Polygon outline layer - zoom'dan bağımsız tutarlı şekil için
      map.current.addLayer({
        id: sourceId + "-outline",
        type: "line",
        source: sourceId,
        paint: {
          'line-color': styleProperties['fill-outline-color'] || '#27ae60',
          'line-width': Math.max(styleProperties['fill-outline-width'] || 2, 3), // En az 3px
          'line-opacity': 1.0,
          'line-cap': 'round',
          'line-join': 'round'
        },
        layout: {
          'line-cap': 'round',
          'line-join': 'round'
        }
      });
    } else if (layerType === "park-polygon-3d" || layerType === "population-3d" || layerType === "parks-3d") {
      // 3D Fill extrusion layer for polygons
      console.log('Adding fill-extrusion layer');
      
      // Eğer fill-extrusion özellikleri varsa 3D, yoksa 2D
      if (styleProperties['fill-extrusion-color'] || styleProperties['fill-extrusion-height']) {
        map.current.addLayer({
          id: sourceId + "-layer",
          type: "fill-extrusion",
          source: sourceId,
          paint: styleProperties
        });
      } else {
        // 2D fill layer
        map.current.addLayer({
          id: sourceId + "-layer",
          type: "fill",
          source: sourceId,
          paint: {
            ...styleProperties,
            'fill-antialias': false  // Şekil değişimlerini önlemek için
          }
        });
        
        // Polygon outline layer - zoom'dan bağımsız tutarlı şekil için
        map.current.addLayer({
          id: sourceId + "-outline",
          type: "line",
          source: sourceId,
          paint: {
            'line-color': styleProperties['fill-outline-color'] || '#27ae60',
            'line-width': Math.max(styleProperties['fill-outline-width'] || 2, 3), // En az 3px
            'line-opacity': 1.0,
            'line-cap': 'round',
            'line-join': 'round'
          },
          layout: {
            'line-cap': 'round',
            'line-join': 'round'
          }
        });
      }
    } else if (layerType === "rivers") {
      // Line layer for rivers
      console.log('Adding line layer');
      map.current.addLayer({
        id: sourceId + "-layer",
        type: "line",
        source: sourceId,
        paint: styleProperties
      });
    } else if (layerType === "parks-polygon-text" || layerType === "parks-3d-text") {
      // Text layer for labels
      console.log('Adding text layer');
      map.current.addLayer({
        id: sourceId + "-text",
        type: "symbol",
        source: sourceId,
        layout: styleProperties
      });
    } else {
      console.log('Unknown layerType:', layerType);
    }
  };

  const loadDynamicData = async () => {
    try {
      // İstanbul parklarını OpenStreetMap'ten çek
      const istanbulParks = await fetchIstanbulParks();
      if (istanbulParks && istanbulParks.elements) {
        const parkData = {
          type: "FeatureCollection",
          features: istanbulParks.elements.map(element => ({
            type: "Feature",
            properties: {
              name: element.tags?.name || "İsimsiz Park",
              type: "osm_park"
            },
            geometry: {
              type: "Point",
              coordinates: [element.lon, element.lat]
            }
          }))
        };
        
        addLocalData(parkData, "parks", {
          'circle-color': 'lightgreen',
          'circle-radius': 6,
          'circle-opacity': 0.7,
          'circle-stroke-color': 'darkgreen',
          'circle-stroke-width': 1
        });
      }

      // Belediye verilerini çek
      const municipalityData = await fetchMunicipalityData("İstanbul");
      console.log("Belediye verileri:", municipalityData);
      
    } catch (error) {
      console.error("Dinamik veri yükleme hatası:", error);
    }
  };

  const addPopups = () => {
    // İstanbul park noktaları popup'ları
    map.current.on('click', 'park-points-layer', (e) => {
      const coordinates = e.features[0].geometry.coordinates.slice();
      const properties = e.features[0].properties;
      
      new maplibregl.Popup()
        .setLngLat(coordinates)
        .setHTML(`
          <div style="padding: 10px; min-width: 200px;">
            <h3 style="margin: 0 0 10px 0; color: #2c3e50;">${properties.name || 'Park'}</h3>
            <p style="margin: 5px 0;"><strong>Alan:</strong> ${properties.area || 'Bilinmiyor'} km²</p>
            <p style="margin: 5px 0;"><strong>Tür:</strong> ${properties.type || 'Park'}</p>
            <p style="margin: 5px 0; font-style: italic; color: #7f8c8d;">İstanbul Park Alanı</p>
          </div>
        `)
        .addTo(map.current);
    });

    // İstanbul park polygon popup'ları
    map.current.on('click', 'park-polygon-layer', (e) => {
      const coordinates = e.features[0].geometry.coordinates[0][0].slice();
      const properties = e.features[0].properties;
      
      new maplibregl.Popup()
        .setLngLat(coordinates)
        .setHTML(`
          <div style="padding: 10px; min-width: 250px;">
            <h3 style="margin: 0 0 10px 0; color: #2c3e50;">${properties.name || 'Park Alanı'}</h3>
            <p style="margin: 5px 0;"><strong>Toplam Park Sayısı:</strong> ${properties.total_parks || 'Bilinmiyor'}</p>
            <p style="margin: 5px 0;"><strong>Toplam Alan:</strong> ${properties.total_area || 'Bilinmiyor'} km²</p>
            <p style="margin: 5px 0; font-style: italic; color: #7f8c8d;">İstanbul'daki tüm park alanlarını kapsayan bölge</p>
          </div>
        `)
        .addTo(map.current);
    });

    // Diğer park popup'ları
    map.current.on('click', 'other-parks-layer', (e) => {
      const coordinates = e.features[0].geometry.coordinates.slice();
      const properties = e.features[0].properties;
      
      new maplibregl.Popup()
        .setLngLat(coordinates)
        .setHTML(`
          <div style="padding: 10px; min-width: 200px;">
            <h3 style="margin: 0 0 10px 0; color: #2c3e50;">${properties.name || 'Park'}</h3>
            <p style="margin: 5px 0;"><strong>Şehir:</strong> ${properties.city || 'Bilinmiyor'}</p>
            <p style="margin: 5px 0;"><strong>Alan:</strong> ${properties.area || 'Bilinmiyor'} km²</p>
            <p style="margin: 5px 0;"><strong>Tür:</strong> ${properties.type || 'Park'}</p>
            <p style="margin: 5px 0; font-style: italic; color: #7f8c8d;">${properties.description || ''}</p>
          </div>
        `)
        .addTo(map.current);
    });

    // Nehir popup'ları
    map.current.on('click', 'rivers-layer', (e) => {
      const coordinates = e.features[0].geometry.coordinates.slice();
      const properties = e.features[0].properties;
      
      new maplibregl.Popup()
        .setLngLat(coordinates)
        .setHTML(`
          <div style="padding: 15px; font-family: Arial, sans-serif; min-width: 200px;">
            <h3 style="margin: 0 0 10px 0; color: #2c3e50; border-bottom: 2px solid #3498db; padding-bottom: 5px;">${properties.name}</h3>
            <div style="display: flex; justify-content: space-between; margin: 8px 0;">
              <span style="color: #7f8c8d; font-weight: bold;">Tür:</span>
              <span style="color: #2c3e50;">${properties.featureclass}</span>
            </div>
            <div style="display: flex; justify-content: space-between; margin: 8px 0;">
              <span style="color: #7f8c8d; font-weight: bold;">Uzunluk:</span>
              <span style="color: #2c3e50;">${properties.length} km</span>
            </div>
            <div style="display: flex; justify-content: space-between; margin: 8px 0;">
              <span style="color: #7f8c8d; font-weight: bold;">Önem:</span>
              <span style="color: #2c3e50;">${properties.scalerank}/3</span>
            </div>
            <div style="margin-top: 10px; padding: 8px; background: #ecf0f1; border-radius: 5px; font-size: 12px; color: #7f8c8d;">
              ${properties.description}
            </div>
          </div>
        `)
        .addTo(map.current);
    });

    // Hover efektleri
    map.current.on('mouseenter', 'parks-layer', () => {
      map.current.getCanvas().style.cursor = 'pointer';
    });

    map.current.on('mouseleave', 'parks-layer', () => {
      map.current.getCanvas().style.cursor = '';
    });

    map.current.on('mouseenter', 'rivers-layer', () => {
      map.current.getCanvas().style.cursor = 'pointer';
    });

    map.current.on('mouseleave', 'rivers-layer', () => {
      map.current.getCanvas().style.cursor = '';
    });

    // Nüfus verileri popup'ları
    map.current.on('click', (e) => {
      const features = map.current.queryRenderedFeatures(e.point, {
        layers: ['population-2d-layer', 'population-3d-layer']
      });
      
      if (features.length > 0) {
        const feature = features[0];
        new maplibregl.Popup()
          .setLngLat(e.lngLat)
          .setHTML(`
            <div style="padding: 15px; font-family: Arial, sans-serif; min-width: 200px;">
              <h3 style="margin: 0 0 10px 0; color: #2c3e50; border-bottom: 2px solid #3498db; padding-bottom: 5px;">${feature.properties.name}</h3>
              <div style="display: flex; justify-content: space-between; margin: 8px 0;">
                <span style="color: #7f8c8d; font-weight: bold;">Nüfus:</span>
                <span style="color: #2c3e50; font-weight: bold;">${feature.properties.population.toLocaleString()}</span>
              </div>
              <div style="display: flex; justify-content: space-between; margin: 8px 0;">
                <span style="color: #7f8c8d; font-weight: bold;">Alan:</span>
                <span style="color: #2c3e50;">${feature.properties.area.toLocaleString()} km²</span>
              </div>
              <div style="margin-top: 10px; padding: 8px; background: #ecf0f1; border-radius: 5px; font-size: 12px; color: #7f8c8d;">
                Nüfus yoğunluğu: ${Math.round(feature.properties.population / feature.properties.area).toLocaleString()} kişi/km²
              </div>
            </div>
          `)
          .addTo(map.current);
      }
    });

    // Önceki popup'ları kapatma değişkeni
    let isPopupOpen = false;
    
    // İstanbul parkları (GeoJSON) için popup'ları - Tüm layer'ları kontrol et
    map.current.on('click', (e) => {
      // Eğer zaten bir popup açıksa, önce onu kapat
      if (isPopupOpen) {
        const existingPopups = document.querySelectorAll('.maplibregl-popup');
        existingPopups.forEach(popup => popup.remove());
      }
      
      // Tüm park layer'larını kontrol et (UUID pattern)
      const features = map.current.queryRenderedFeatures(e.point);
      
      // Park özelliklerine sahip feature'ları bul
      const parkFeatures = features.filter(f => 
        f.properties && 
        (f.properties.name || f.properties['MAHAL ADI'] || f.properties.type === 'park') &&
        f.geometry.type === 'Polygon'
      );
      
      if (parkFeatures.length > 0) {
        const feature = parkFeatures[0];
        const properties = feature.properties;
        
        // Koordinatları al (polygon'dan centroid - sadece [lng, lat] al)
        const coords = feature.geometry.coordinates[0];
        const lng = coords.reduce((sum, coord) => sum + coord[0], 0) / coords.length;
        const lat = coords.reduce((sum, coord) => sum + coord[1], 0) / coords.length;
        
        // Sadece boş olmayan property'leri göster
        let propertiesHTML = '';
        Object.keys(properties).forEach(key => {
          if (key !== 'id') {
            const value = properties[key];
            // null, undefined, boş string kontrolü - daha detaylı
            const hasValue = value !== null && 
                           value !== undefined && 
                           value !== '' && 
                           value !== 'null' &&
                           String(value).trim() !== '';
            
            if (hasValue) {
              let displayValue;
              if (typeof value === 'boolean') {
                displayValue = value ? 'Evet' : 'Hayır';
              } else if (typeof value === 'number') {
                displayValue = value.toString();
              } else {
                displayValue = String(value);
              }
              
              propertiesHTML += `
                <div style="display: flex; justify-content: space-between; margin: 6px 0; padding: 4px 0; border-bottom: 1px solid #ecf0f1;">
                  <span style="color: #7f8c8d; font-weight: bold; flex: 1;">${key}:</span>
                  <span style="color: #2c3e50; margin-left: 10px; flex: 1; text-align: right;">${displayValue}</span>
                </div>
              `;
            }
          }
        });
        
        const parkName = properties.name || properties['MAHAL ADI'] || 'Park';
        
        // Önce tüm mevcut popup'ları kaldır
        const existingPopups = document.querySelectorAll('.maplibregl-popup');
        existingPopups.forEach(p => p.remove());
        
        const popup = new maplibregl.Popup({ 
          closeOnClick: true,
          anchor: 'center',
          offset: [0, -20],
          closeButton: true,
          className: 'custom-popup'
        })
          .setLngLat([lng, lat])
          .setHTML(`
            <div class="popup-container" style="padding: 0; font-family: Arial, sans-serif; min-width: 320px; max-width: 450px; background-color: white; border-radius: 8px; box-shadow: 0 4px 6px rgba(0,0,0,0.2);">
              <div class="popup-header" style="cursor: move; padding: 15px; background: linear-gradient(135deg, #27ae60 0%, #2ecc71 100%); color: white; border-radius: 8px 8px 0 0;">
                <h3 style="margin: 0; font-size: 16px; font-weight: bold; user-select: none;">${parkName}</h3>
              </div>
              <div style="max-height: 400px; overflow-y: auto; padding: 15px;">
                ${propertiesHTML}
              </div>
            </div>
          `)
          .addTo(map.current);
        
        isPopupOpen = true;
        
        // Popup kapandığında flag'i sıfırla
        popup.on('close', () => {
          isPopupOpen = false;
        });
        
        // Drag özelliği ekle - daha sonra event listener'ları eklemek için setTimeout
        setTimeout(() => {
          const popupElement = popup.getElement();
          const header = popupElement.querySelector('.popup-header');
          
          if (header) {
            let isDragging = false;
            let startX, startY;
            let offsetX = 0, offsetY = 0;
            
            const dragStart = (e) => {
              e.stopPropagation();
              if (e.target === header || header.contains(e.target)) {
                // Mevcut popup pozisyonunu al
                const rect = popupElement.getBoundingClientRect();
                const currentLeft = rect.left;
                const currentTop = rect.top;
                
                if (e.type === "touchstart") {
                  startX = e.touches[0].clientX - currentLeft;
                  startY = e.touches[0].clientY - currentTop;
                } else {
                  startX = e.clientX - currentLeft;
                  startY = e.clientY - currentTop;
                }
                
                // Mevcut pozisyonu kaydet
                isDragging = true;
              }
            };
            
            const drag = (e) => {
              if (isDragging) {
                e.preventDefault();
                e.stopPropagation();
                
                let clientX, clientY;
                if (e.type === "touchmove") {
                  clientX = e.touches[0].clientX;
                  clientY = e.touches[0].clientY;
                } else {
                  clientX = e.clientX;
                  clientY = e.clientY;
                }

                // Mouse pozisyonundan startX/Y offset'ini çıkar
                const newOffsetX = clientX - startX;
                const newOffsetY = clientY - startY;

                popupElement.style.position = 'fixed';
                popupElement.style.left = newOffsetX + 'px';
                popupElement.style.top = newOffsetY + 'px';
                popupElement.style.transform = 'none';
                popupElement.style.margin = '0';
                popupElement.style.zIndex = '1000';
              }
            };
            
            const dragEnd = (e) => {
              if (isDragging) {
                isDragging = false;
              }
            };
            
            header.addEventListener('mousedown', dragStart);
            header.addEventListener('touchstart', dragStart);
            
            document.addEventListener('mousemove', drag);
            document.addEventListener('touchmove', drag);
            
            document.addEventListener('mouseup', dragEnd);
            document.addEventListener('touchend', dragEnd);
            
            // Popup kapanırken event listener'ları temizle
            popup.on('close', () => {
              header.removeEventListener('mousedown', dragStart);
              header.removeEventListener('touchstart', dragStart);
              document.removeEventListener('mousemove', drag);
              document.removeEventListener('touchmove', drag);
              document.removeEventListener('mouseup', dragEnd);
              document.removeEventListener('touchend', dragEnd);
            });
          }
        }, 100);
      }
    });
  };

  // Örnek yükleme fonksiyonları
  const loadPopulation2D = () => {
    addLocalData(turkeyPopulationData, "population-2d", {
      'circle-color': [
        'step',
        ['get', 'population'],
        '#00FF00',    // 0-500K: Yeşil
        500000,
        '#FFFF00',    // 500K-1M: Sarı
        1000000,
        '#FFA500',    // 1M-3M: Turuncu
        3000000,
        '#FF0000',    // 3M+: Kırmızı
        5000000,
        '#8B0000'     // 5M+: Koyu kırmızı
      ],
      'circle-opacity': 0.8,
      'circle-stroke-color': 'white',
      'circle-stroke-width': 2,
      'circle-radius': [
        'step',
        ['get', 'population'],
        8,      // 0-500K: 8px
        500000,
        12,     // 500K-1M: 12px
        1000000,
        16,     // 1M-3M: 16px
        3000000,
        20,     // 3M+: 20px
        5000000,
        24      // 5M+: 24px
      ]
    });
    
    // Nüfus sayılarını gösteren text layer ekle
    addPopulationTextLayer();
  }

  const addPopulationTextLayer = () => {
    const sourceId = uuidv4();
    const sourceInstance = geojsonSource(turkeyPopulationData);
    map.current.addSource(sourceId, sourceInstance);
    
    map.current.addLayer({
      id: sourceId + "-text",
      type: "symbol",
      source: sourceId,
      layout: {
        "text-field": ["get", "displayValue"],
        "text-font": ["Open Sans Bold", "Arial Unicode MS Bold"],
        "text-size": [
          'step',
          ['get', 'population'],
          10,      // 0-500K: 10px
          500000,
          12,      // 500K-1M: 12px
          1000000,
          14,      // 1M-3M: 14px
          3000000,
          16,      // 3M+: 16px
          5000000,
          18       // 5M+: 18px
        ],
        "text-offset": [0, 0],
        "text-anchor": "center",
        "text-allow-overlap": true,
        "text-ignore-placement": true
      },
      paint: {
        "text-color": "white",
        "text-halo-color": "black",
        "text-halo-width": 1.5,
        "text-halo-blur": 1
      }
    });
  }

  const loadPopulation3D = () => {
    addLocalData(turkeyPopulation3DData, "population-3d", {
      'fill-extrusion-color': [
        'step',
        ['get', 'population'],
        '#00FF00',    // 0-500K: Yeşil
        500000,
        '#FFFF00',    // 500K-1M: Sarı
        1000000,
        '#FFA500',    // 1M-3M: Turuncu
        3000000,
        '#FF0000',    // 3M+: Kırmızı
        5000000,
        '#8B0000'     // 5M+: Koyu kırmızı
      ],
      'fill-extrusion-opacity': 0.8,
      'fill-extrusion-height': ["/", ["get", "population"], 50], // Medium makalesindeki gibi nüfus/50
      'fill-extrusion-base': 0
    });
    
    // 3D nüfus sayılarını gösteren text layer ekle
    addPopulation3DTextLayer();
  }

  const addPopulation3DTextLayer = () => {
    const sourceId = uuidv4();
    const sourceInstance = geojsonSource(turkeyPopulation3DData);
    map.current.addSource(sourceId, sourceInstance);
    
    map.current.addLayer({
      id: sourceId + "-text",
      type: "symbol",
      source: sourceId,
      layout: {
        "text-field": ["get", "displayValue"],
        "text-font": ["Open Sans Bold", "Arial Unicode MS Bold"],
        "text-size": [
          'step',
          ['get', 'population'],
          10,      // 0-500K: 10px
          500000,
          12,      // 500K-1M: 12px
          1000000,
          14,      // 1M-3M: 14px
          3000000,
          16,      // 3M+: 16px
          5000000,
          18       // 5M+: 18px
        ],
        "text-offset": [0, 0],
        "text-anchor": "center",
        "text-allow-overlap": true,
        "text-ignore-placement": true
      },
      paint: {
        "text-color": "white",
        "text-halo-color": "black",
        "text-halo-width": 1.5,
        "text-halo-blur": 1
      }
    });
  }

  const loadRivers = async () => {
    // GitHub'daki nehir verilerini yükle
    addGeojsonSource("https://raw.githubusercontent.com/utahemre/maplibre-gl-example-project/master/public/testdata/rivers.geojson",
      addLineLayer, {
        'line-color' : [
          'match',
          ['get', 'featureclass'],
          "River", "blue",
          "Lake Centerline", "red",
          "black"
        ], 
        'line-opacity' : 0.8, 
        'line-width' : ['get', 'scalerank']
      }
    );
  }

  const loadParksPolygon = () => {
    console.log('Loading parks polygon data:', istanbulParkPolygon);
    console.log('Number of features:', istanbulParkPolygon.features.length);
    
    // Önce basit bir test polygon'u ekleyelim
    const testPolygon = {
      "type": "FeatureCollection",
      "features": [
        {
          "type": "Feature",
          "properties": {
            "name": "Test 2D Polygon",
            "total_area": 25.0,
            "type": "park"
          },
          "geometry": {
            "type": "Polygon",
            "coordinates": [[
              [29.0, 41.0],
              [29.2, 41.0],
              [29.2, 41.2],
              [29.0, 41.2],
              [29.0, 41.0]
            ]]
          }
        }
      ]
    };
    
    console.log('Adding test polygon...');
    addLocalData(testPolygon, "parks-3d", {
      'fill-color': '#FF0000',
      'fill-opacity': 0.8,
      'fill-outline-color': 'darkgreen',
      'fill-outline-width': 2
    });
    
    // Şimdi asıl polygon'ları ekleyelim
    console.log('Adding main polygons...');
    addLocalData(istanbulParkPolygon, "parks-3d", {
      'fill-color': [
        'step',
        ['get', 'total_area'],
        '#00FF00',  // Yeşil - küçük parklar
        20,
        '#FFFF00',  // Sarı - orta parklar
        30,
        '#FFA500',  // Turuncu - büyük parklar
        40,
        '#FF0000',  // Kırmızı - çok büyük parklar
        50,
        '#8B0000'   // Koyu kırmızı - en büyük parklar
      ],
      'fill-opacity': 0.8,
      'fill-outline-color': 'darkgreen',
      'fill-outline-width': 2
    });
    
    // Polygon'ların üzerine şekil isimlerini yazdır
    addLocalData(istanbulParkPolygon, "parks-3d-text", {
      'text-field': ['get', 'name'],
      'text-font': ['Open Sans Regular', 'Arial Unicode MS Regular'],
      'text-size': 10,
      'text-color': '#000000',
      'text-halo-color': '#FFFFFF',
      'text-halo-width': 1,
      'text-anchor': 'center',
      'text-allow-overlap': true
    });
  }

  const loadParks3D = () => {
    console.log('Loading parks 3D data:', istanbulParkPolygon);
    addLocalData(istanbulParkPolygon, "parks-3d", {
      'fill-extrusion-color': [
        'step',
        ['get', 'total_area'],
        '#00FF00',  // Yeşil - küçük parklar
        20,
        '#FFFF00',  // Sarı - orta parklar
        30,
        '#FFA500',  // Turuncu - büyük parklar
        40,
        '#FF0000',  // Kırmızı - çok büyük parklar
        50,
        '#8B0000'   // Koyu kırmızı - en büyük parklar
      ],
      'fill-extrusion-opacity': 0.8,
      'fill-extrusion-height': [
        'interpolate',
        ['linear'],
        ['get', 'total_area'],
        0, 50,    // En küçük parklar 50m yükseklik
        10, 100,  // 10 hektar parklar 100m yükseklik
        20, 150,  // 20 hektar parklar 150m yükseklik
        30, 200,  // 30 hektar parklar 200m yükseklik
        40, 250,  // 40 hektar parklar 250m yükseklik
        50, 300   // En büyük parklar 300m yükseklik
      ],
      'fill-extrusion-base': 0
    });
    
    // 3D polygon'ların üzerine şekil isimlerini yazdır
    addLocalData(istanbulParkPolygon, "parks-3d-text", {
      'text-field': ['get', 'name'],
      'text-font': ['Open Sans Regular', 'Arial Unicode MS Regular'],
      'text-size': 10,
      'text-color': '#000000',
      'text-halo-color': '#FFFFFF',
      'text-halo-width': 1,
      'text-anchor': 'center',
      'text-allow-overlap': true
    });
  }

  // Yeni İstanbul parkları (2D) fonksiyonu
  const loadIstanbulParks2D = async () => {
    console.log('Loading Istanbul parks 2D data from GeoJSON file');
    
    try {
      // GeoJSON dosyasını yükle
      const response = await axios.get(`${process.env.PUBLIC_URL || ''}/testdata/parks.geojson`, {
        headers: { 'Accept': 'application/json, application/geo+json' }
      });
      const parkData = response.data;
      
      console.log('Park data loaded:', parkData);
      
      // Poligon parkları ekle
      addLocalData(parkData, "parks-3d", {
        'fill-color': [
          'step',
          ['get', 'area'],
          '#00FF00',  // Yeşil - küçük parklar (<20)
          20,
          '#FFFF00',  // Sarı - orta parklar (20-30)
          30,
          '#FFA500',  // Turuncu - büyük parklar (>30)
          '#8B0000'   // Koyu kırmızı
        ],
        'fill-opacity': 0.6,
        'fill-outline-color': '#2c3e50',
        'fill-outline-width': 2
      });
      
      // Park isimlerini göster
      addLocalData(parkData, "parks-3d-text", {
        'text-field': ['get', 'name'],
        'text-font': ['Open Sans Bold', 'Arial Unicode MS Bold'],
        'text-size': 12,
        'text-color': '#000000',
        'text-halo-color': '#FFFFFF',
        'text-halo-width': 2,
        'text-halo-blur': 1,
        'text-anchor': 'center',
        'text-allow-overlap': true,
        'text-ignore-placement': true
      });
      
      // Text layer için layout ve paint özelliklerini ayır
      // addLocalData fonksiyonu zaten layout kullanıyor, sorun yok
    } catch (error) {
      console.error("GeoJSON yükleme hatası:", error);
    }
  };

  // Yeni İstanbul parkları (3D) fonksiyonu
  const loadIstanbulParks3D = async () => {
    console.log('Loading Istanbul parks 3D data from GeoJSON file');
    
    try {
      // GeoJSON dosyasını yükle
      const response = await axios.get(`${process.env.PUBLIC_URL || ''}/testdata/parks.geojson`, {
        headers: { 'Accept': 'application/json, application/geo+json' }
      });
      const parkData = response.data;
      
      console.log('Park data loaded:', parkData);
      
      // Harita pitch'ini ayarla (3D görünüm için)
      if (map.current) {
        map.current.easeTo({
          pitch: 45,
          bearing: 0,
          duration: 1000
        });
      }
      
      // Poligon parkları 3D olarak ekle
      addLocalData(parkData, "parks-3d", {
        'fill-extrusion-color': [
          'step',
          ['get', 'area'],
          '#00FF00',  // Yeşil - küçük parklar
          20,
          '#FFFF00',  // Sarı - orta parklar
          30,
          '#FFA500',  // Turuncu - büyük parklar
          '#8B0000'   // Koyu kırmızı
        ],
        'fill-extrusion-opacity': 0.8,
        'fill-extrusion-height': [
          'interpolate',
          ['linear'],
          ['get', 'area'],
          0, 100,    // En küçük parklar 100m
          15, 200,   // 15 hektar parklar 200m
          20, 250,   // 20 hektar parklar 250m
          30, 300    // En büyük parklar 300m
        ],
        'fill-extrusion-base': 0
      });
      
      // Park isimlerini göster
      addLocalData(parkData, "parks-3d-text", {
        'text-field': ['get', 'name'],
        'text-font': ['Open Sans Bold', 'Arial Unicode MS Bold'],
        'text-size': 12,
        'text-color': '#000000',
        'text-halo-color': '#FFFFFF',
        'text-halo-width': 2,
        'text-halo-blur': 1,
        'text-anchor': 'center',
        'text-allow-overlap': true,
        'text-ignore-placement': true
      });
    } catch (error) {
      console.error("GeoJSON yükleme hatası:", error);
    }
  };

  // Ankara parkları (2D) fonksiyonu
  const loadAnkaraParks2D = async () => {
    console.log('Loading Ankara parks 2D data from GeoJSON file');
    
    try {
      // anpark.geojson dosyasını yükle (Z koordinatı olmayan temiz versiyon)
      const response = await axios.get(`${process.env.PUBLIC_URL || ''}/testdata/anpark.geojson`, {
        headers: { 'Accept': 'application/json, application/geo+json' }
      });
      const parkData = response.data;
      
      console.log('Park data loaded:', parkData);
      
      // Poligon parkları ekle - alan bazlı renklendirme (2D fill)
      addLocalData(parkData, "parks-polygon", {
        'fill-color': [
          'interpolate',
          ['linear'],
          ['+', 
            ['get', 'ÇİM (m2)'],
            ['get', 'SERT (m2)'],
            ['get', 'KALDIRIM (m2)']
          ],
          0, '#00FF00',
          5000, '#FFFF00',
          10000, '#FFA500',
          15000, '#FF0000'
        ],
        'fill-opacity': 0.8,
        'fill-outline-color': '#000000',
        'fill-outline-width': 4
      });
      
      // Park isimlerini göster
      addLocalData(parkData, "parks-3d-text", {
        'text-field': ['get', 'MAHAL ADI'],
        'text-font': ['Open Sans Bold', 'Arial Unicode MS Bold'],
        'text-size': 13,
        'text-color': '#000000',
        'text-halo-color': '#FFFFFF',
        'text-halo-width': 2.5,
        'text-halo-blur': 1,
        'text-anchor': 'center',
        'text-allow-overlap': true,
        'text-ignore-placement': true
      });
    } catch (error) {
      console.error("Ankara parkları GeoJSON yükleme hatası:", error);
    }
  };

  // Ankara parkları (3D) fonksiyonu
  const loadAnkaraParks3D = async () => {
    console.log('Loading Ankara parks 3D data from GeoJSON file');
    
    try {
      // anpark.geojson dosyasını yükle (Z koordinatı olmayan temiz versiyon)
      const response = await axios.get(`${process.env.PUBLIC_URL || ''}/testdata/anpark.geojson`, {
        headers: { 'Accept': 'application/json, application/geo+json' }
      });
      const parkData = response.data;
      
      console.log('Park data loaded:', parkData);
      
      // Harita pitch'ini ayarla (3D görünüm için)
      if (map.current) {
        map.current.easeTo({
          pitch: 50,
          bearing: 0,
          zoom: 14,
          center: [32.82, 39.96],
          duration: 1500
        });
      }
      
      // Poligon parkları 3D olarak ekle - alan bazlı yükseklik
      addLocalData(parkData, "parks-3d", {
        'fill-extrusion-color': [
          'interpolate',
          ['linear'],
          ['+',
            ['get', 'ÇİM (m2)'],
            ['get', 'SERT (m2)'],
            ['get', 'KALDIRIM (m2)']
          ],
          0, '#00FF00',
          5000, '#FFFF00',
          10000, '#FFA500',
          15000, '#FF0000'
        ],
        'fill-extrusion-opacity': 0.85,
        'fill-extrusion-height': [
          'interpolate',
          ['linear'],
          ['+',
            ['get', 'ÇİM (m2)'],
            ['get', 'SERT (m2)'],
            ['get', 'KALDIRIM (m2)']
          ],
          0, 80,
          5000, 120,
          10000, 160,
          15000, 200
        ],
        'fill-extrusion-base': 0
      });
      
      // Park isimlerini göster
      addLocalData(parkData, "parks-3d-text", {
        'text-field': ['get', 'MAHAL ADI'],
        'text-font': ['Open Sans Bold', 'Arial Unicode MS Bold'],
        'text-size': 13,
        'text-color': '#000000',
        'text-halo-color': '#FFFFFF',
        'text-halo-width': 2.5,
        'text-halo-blur': 1,
        'text-anchor': 'center',
        'text-allow-overlap': true,
        'text-ignore-placement': true
      });
    } catch (error) {
      console.error("Ankara parkları GeoJSON yükleme hatası:", error);
    }
  };

  // ABB parkları (2D) fonksiyonu
  const loadABBParks2D = async () => {
    console.log('Loading ABB parks 2D data from GeoJSON file');
    
    try {
      // abb.geojson dosyasını yükle
      const response = await axios.get(`${process.env.PUBLIC_URL || ''}/testdata/abb.geojson`, {
        headers: { 'Accept': 'application/json, application/geo+json' }
      });
      const rawData = response.data;
      
      console.log('ABB raw data:', rawData);
      
      // Z koordinatlarını kaldır (sadece [lng, lat] kalacak)
      const cleanParkData = {
        type: "FeatureCollection",
        features: rawData.features.map(feature => ({
          ...feature,
          geometry: {
            ...feature.geometry,
            coordinates: feature.geometry.coordinates.map(ring => 
              ring.map(coord => [coord[0], coord[1]]) // Sadece lng, lat
            )
          }
        }))
      };
      
      console.log('ABB Park data loaded (Z koordinatları kaldırıldı):', cleanParkData);
      
      // 3D gibi ama çok ince yükseklik - 2D görünüm için
      addLocalData(cleanParkData, "parks-3d", {
        'fill-extrusion-color': '#27ae60',
        'fill-extrusion-opacity': 0.8,
        'fill-extrusion-height': 0.1,  // Çok ince - neredeyse düz
        'fill-extrusion-base': 0
      });
      
      // Park isimlerini göster - text layer
      const textSourceId = uuidv4();
      const textSourceInstance = geojsonSource(cleanParkData);
      map.current.addSource(textSourceId, textSourceInstance);
      
      map.current.addLayer({
        id: textSourceId + "-text",
        type: "symbol",
        source: textSourceId,
        layout: {
          'text-field': ['get', 'MAHAL ADI'],
          'text-font': ['Open Sans Bold', 'Arial Unicode MS Bold'],
          'text-size': 13,
          'text-anchor': 'center',
          'text-allow-overlap': true,
          'text-ignore-placement': true
        },
        paint: {
          'text-color': '#000000',
          'text-halo-color': '#FFFFFF',
          'text-halo-width': 2.5,
          'text-halo-blur': 1
        }
      });
    } catch (error) {
      console.error("ABB parkları GeoJSON yükleme hatası:", error);
    }
  };

  // ABB parkları (3D) fonksiyonu
  const loadABBParks3D = async () => {
    console.log('Loading ABB parks 3D data from GeoJSON file');
    
    try {
      // abb.geojson dosyasını yükle
      const response = await axios.get(`${process.env.PUBLIC_URL || ''}/testdata/abb.geojson`, {
        headers: { 'Accept': 'application/json, application/geo+json' }
      });
      const parkData = response.data;
      
      console.log('ABB Park data loaded:', parkData);
      
      // Harita pitch'ini ayarla (3D görünüm için)
      if (map.current) {
        map.current.easeTo({
          pitch: 50,
          bearing: 0,
          zoom: 14,
          center: [32.82, 39.96],
          duration: 1500
        });
      }
      
      // Poligon parkları 3D olarak ekle
      addLocalData(parkData, "parks-3d", {
        'fill-extrusion-color': '#27ae60',
        'fill-extrusion-opacity': 0.85,
        'fill-extrusion-height': 100,
        'fill-extrusion-base': 0
      });
      
      // Park isimlerini göster - text layer
      const textSourceId = uuidv4();
      const textSourceInstance = geojsonSource(parkData);
      map.current.addSource(textSourceId, textSourceInstance);
      
      map.current.addLayer({
        id: textSourceId + "-text",
        type: "symbol",
        source: textSourceId,
        layout: {
          'text-field': ['get', 'MAHAL ADI'],
          'text-font': ['Open Sans Bold', 'Arial Unicode MS Bold'],
          'text-size': 13,
          'text-anchor': 'center',
          'text-allow-overlap': true,
          'text-ignore-placement': true
        },
        paint: {
          'text-color': '#000000',
          'text-halo-color': '#FFFFFF',
          'text-halo-width': 2.5,
          'text-halo-blur': 1
        }
      });
    } catch (error) {
      console.error("ABB parkları GeoJSON yükleme hatası:", error);
    }
  };

  // Ankara parkları (3D Kısa) - daha kısa yükseklik
  const loadAnkaraParks3DShort = async () => {
    console.log('Loading Ankara parks 3D SHORT data from GeoJSON file');
    
    try {
      const response = await axios.get(`${process.env.PUBLIC_URL || ''}/testdata/anpark.geojson`, {
        headers: { 'Accept': 'application/json, application/geo+json' }
      });
      const parkData = response.data;
      
      console.log('Park data loaded:', parkData);
      
      if (map.current) {
        map.current.easeTo({
          pitch: 45,
          bearing: 0,
          zoom: 14,
          center: [32.82, 39.96],
          duration: 1500
        });
      }
      
      // Daha kısa yükseklikler (normal 3D'nin %40'ı)
      addLocalData(parkData, "parks-3d", {
        'fill-extrusion-color': [
          'interpolate',
          ['linear'],
          ['+',
            ['get', 'ÇİM (m2)'],
            ['get', 'SERT (m2)'],
            ['get', 'KALDIRIM (m2)']
          ],
          0, '#00FF00',
          5000, '#FFFF00',
          10000, '#FFA500',
          15000, '#FF0000'
        ],
        'fill-extrusion-opacity': 0.85,
        'fill-extrusion-height': [
          'interpolate',
          ['linear'],
          ['+',
            ['get', 'ÇİM (m2)'],
            ['get', 'SERT (m2)'],
            ['get', 'KALDIRIM (m2)']
          ],
          0, 15,      // Kısa 3D: 30 -> 15 (yarısı)
          5000, 25,   // Kısa 3D: 50 -> 25 (yarısı)
          10000, 30,  // Kısa 3D: 60 -> 30 (yarısı)
          15000, 40   // Kısa 3D: 80 -> 40 (yarısı)
        ],
        'fill-extrusion-base': 0
      });
      
      // Text layer
      const textSourceId = uuidv4();
      const textSourceInstance = geojsonSource(parkData);
      map.current.addSource(textSourceId, textSourceInstance);
      
      map.current.addLayer({
        id: textSourceId + "-text",
        type: "symbol",
        source: textSourceId,
        layout: {
          'text-field': ['get', 'MAHAL ADI'],
          'text-font': ['Open Sans Bold', 'Arial Unicode MS Bold'],
          'text-size': 11,
          'text-anchor': 'center',
          'text-allow-overlap': true,
          'text-ignore-placement': true
        },
        paint: {
          'text-color': '#000000',
          'text-halo-color': '#FFFFFF',
          'text-halo-width': 2,
          'text-halo-blur': 1
        }
      });
    } catch (error) {
      console.error("Ankara parkları 3D Short yükleme hatası:", error);
    }
  };

  // ABB parkları (3D Kısa) - daha kısa yükseklik
  const loadABBParks3DShort = async () => {
    console.log('Loading ABB parks 3D SHORT data from GeoJSON file');
    
    try {
      const response = await axios.get(`${process.env.PUBLIC_URL || ''}/testdata/abb.geojson`, {
        headers: { 'Accept': 'application/json, application/geo+json' }
      });
      const parkData = response.data;
      
      console.log('ABB Park data loaded:', parkData);
      
      if (map.current) {
        map.current.easeTo({
          pitch: 45,
          bearing: 0,
          zoom: 14,
          center: [32.82, 39.96],
          duration: 1500
        });
      }
      
      // Kısa 3D yükseklik (100 -> 40)
      addLocalData(parkData, "parks-3d", {
        'fill-extrusion-color': '#27ae60',
        'fill-extrusion-opacity': 0.85,
        'fill-extrusion-height': 20,  // Kısa 3D: 40 -> 20 (yarısı)
        'fill-extrusion-base': 0
      });
      
      // Text layer
      const textSourceId = uuidv4();
      const textSourceInstance = geojsonSource(parkData);
      map.current.addSource(textSourceId, textSourceInstance);
      
      map.current.addLayer({
        id: textSourceId + "-text",
        type: "symbol",
        source: textSourceId,
        layout: {
          'text-field': ['get', 'MAHAL ADI'],
          'text-font': ['Open Sans Bold', 'Arial Unicode MS Bold'],
          'text-size': 11,
          'text-anchor': 'center',
          'text-allow-overlap': true,
          'text-ignore-placement': true
        },
        paint: {
          'text-color': '#000000',
          'text-halo-color': '#FFFFFF',
          'text-halo-width': 2,
          'text-halo-blur': 1
        }
      });
    } catch (error) {
      console.error("ABB parkları 3D Short yükleme hatası:", error);
    }
  };

  // loadAllExamples fonksiyonu kaldırıldı - artık "Tüm Örnekler" butonu yok

  // Bölgesel filtreleme
  const handleRegionSelect = async (districtName) => {
    console.log('İlçe seçildi:', districtName);
    setActiveRegion(districtName);
    
    if (!map.current || !map.current.loaded()) {
      console.log('Harita henüz yüklenmedi');
      return;
    }
    
    try {
      // Tüm parkları yükle - import edilen dosyayı kullan (routing problemi olmadan)
      console.log('📍 Park verileri yükleniyor... (import edilmiş dosya)');
      console.log('🔍 Import edilen data:', abbParkData);
      console.log('📦 Data tipi:', typeof abbParkData);
      
      // Import edilen dosya direkt kullanılıyor - HTTP isteği yok
      const allParkData = abbParkData;
      
      console.log('✅ Park verisi yüklendi (import)');
      console.log('📊 Toplam park sayısı (yüklenen):', allParkData.features?.length || 0);
      
      // Debug: Tüm benzersiz İSTASYON İSMİ değerlerini göster
      const uniqueIstasyonIsimleri = [...new Set(allParkData.features?.map(f => f.properties['İSTASYON İSMİ']).filter(Boolean) || [])];
      console.log('📋 Tüm benzersiz İSTASYON İSMİ değerleri:', uniqueIstasyonIsimleri.sort());
      
      if (!allParkData) {
        console.error('❌ allParkData null veya undefined!');
        alert('Park verileri yüklenemedi. Dosya import edilemedi.');
        return;
      }
      
      if (!allParkData.features || !Array.isArray(allParkData.features)) {
        console.error('❌ GeoJSON formatı geçersiz veya veri yüklenemedi.');
        console.error('❌ Data içeriği:', allParkData);
        console.error('❌ Features:', allParkData.features);
        alert('Park verileri yüklenemedi. GeoJSON formatı hatalı.');
        return;
      }
      
      console.log('📋 Toplam park sayısı:', allParkData.features.length);
      
      // İlçe-even İSTASYON İSMİ filtreleme patterns
      const districtFilters = {
        "Akyurt": ["akyurt"],
        "Beypazarı": ["beypazari", "beypazarı", "beypazari"],
        "Çankaya": ["ankaya", "çankaya", "?ankaya", "caldag", "caldağ", "tbmm", "?alda?", "?aldag", "?ankaya/?alda?", "?ankaya/tbmm"],
        "Elmadağ": ["elmadağ", "elmadag", "elmada? barutsan fabrikasi", "elmada? radar sahasi", "elmada?/ye?ildere"],
        "Etimesgut": ["etimesgut", "etimesgut havalimanı", "etimesgut havalimani", "et?mesgut haval?mani", "etimesgut"],
        "Gölbaşı": ["golbasi", "gölbaşı", "g?lba?i", "genclik parki", "gençlik parkı", "ufuk danisman", "ufuk danışman", "altındağ", "g?lba?i/ah?boz k?y?", "g?lba?i/ufuk dani?ment", "g?lba?i/ya?lipinar k?y?"],
        "Haymana": ["haymana", "haymana tarim"],
        "Keçiören": ["kecoren", "keçiören", "mgm", "ke???ren/9. (ankara) b?lge", "ke???ren/ba?lum", "ke?i?ren/mgm"],
        "Kazan": ["kazan", "kahramankazan", "kazan/kurtbo?azi baraji", "kazan/sarayk?y toprak"],
        "Mamak": ["mamak", "bayindir baraji", "bayındır barajı", "mamak/bayindir baraji"],
        "Nallıhan": ["nallihan", "nallıhan", "nallihan/sariyar"],
        "Polatlı": ["polatli", "polatlı"],
        "Pursaklar": ["pursaklar"],
        "Sincan": ["sincan", "temelli", "s?ncan", "s?ncan/temell?"], // ? karakteri ile encode edilmiş versiyonlar
        "Yenimahalle": ["yenimahalle"]
      };
      
      // Seçilen ilçeye göre filtrele - İSTASYON İSMİ kullanarak
      const filters = districtFilters[districtName];
      console.log(`🔍 Seçilen ilçe: ${districtName}, Filter pattern'leri:`, filters);
      
      // Debug: Seçilen ilçe için İSTASYON İSMİ'nde geçen parkları göster
      if (districtName === 'Sincan') {
        const sincanRelated = allParkData.features.filter(f => {
          const istasyon = (f.properties['İSTASYON İSMİ'] || '').toLowerCase();
          return istasyon.includes('sincan') || istasyon.includes('temelli') || istasyon.includes('sin') || istasyon.includes('sinc');
        });
        console.log(`🔍 Sincan ile ilgili parklar (debug):`, sincanRelated.map(f => ({
          mahalAdi: f.properties['MAHAL ADI'],
          istasyonIsmi: f.properties['İSTASYON İSMİ']
        })));
      }
      
      // Tüm parkları filtrele
      let filteredFeatures = allParkData.features.filter(feature => {
        const istasyonIsmi = feature.properties['İSTASYON İSMİ'];
        
        if (!istasyonIsmi) {
          // Boşta kalan parkları "Genel" kategorisine ekle
          return false;
        }
        
        // Normalize Turkish characters (including ? character)
        // Önce ? karakterleriyle başlayalım (encoding sorunu olabilir)
        const normalized = istasyonIsmi.toLowerCase();
        
        // Check if any filter matches
        if (filters) {
          for (const filter of filters) {
            const normalizedFilter = filter.toLowerCase();
            
            // Multiple matching strategies:
            // 1. Direct string comparison (case-insensitive)
            // 2. Normalized comparison (without Turkish chars)
            // 3. Check if filter is substring of istasyon or vice versa
            const normalizedFilterLower = filter.toLowerCase();
            const normalizedIstasyon = normalized
              .replace(/ı/g, 'i')
              .replace(/İ/g, 'i')
              .replace(/ğ/g, 'g')
              .replace(/Ğ/g, 'g')
              .replace(/ü/g, 'u')
              .replace(/Ü/g, 'u')
              .replace(/ş/g, 's')
              .replace(/Ş/g, 's')
              .replace(/ö/g, 'o')
              .replace(/Ö/g, 'o')
              .replace(/ç/g, 'c')
              .replace(/Ç/g, 'c')
              .replace(/[?ï]/g, 'i') // ? ve ï karakterlerini i'ye çevir
              .replace(/[ûù]/g, 'u') // û ve ù karakterlerini u'ya çevir
              .replace(/[âä]/g, 'a') // â ve ä karakterlerini a'ya çevir
              .replace(/[êë]/g, 'e') // ê ve ë karakterlerini e'ye çevir
              .replace(/[ô]/g, 'o'); // ô karakterini o'ya çevir
            
            const normalizedFilterForMatch = normalizedFilterLower
              .replace(/ı/g, 'i')
              .replace(/ğ/g, 'g')
              .replace(/ü/g, 'u')
              .replace(/ş/g, 's')
              .replace(/ö/g, 'o')
              .replace(/ç/g, 'c')
              .replace(/[?ï]/g, 'i')
              .replace(/[ûù]/g, 'u')
              .replace(/[âä]/g, 'a')
              .replace(/[êë]/g, 'e')
              .replace(/[ô]/g, 'o');
            
            // Check multiple conditions
            if (normalized.includes(normalizedFilterLower) || 
                normalizedFilterLower.includes(normalized) ||
                normalizedIstasyon.includes(normalizedFilterForMatch) ||
                normalizedFilterForMatch.includes(normalizedIstasyon) ||
                istasyonIsmi.toLowerCase().includes(normalizedFilterLower) ||
                normalizedFilterLower.includes(istasyonIsmi.toLowerCase())) {
              console.log(`✅ Park eşleşti: ${feature.properties['MAHAL ADI']}, İstasyon: ${istasyonIsmi}, Filter: ${filter}`);
              return true;
            }
          }
        }
        
        return false;
      });
      
      const filteredData = {
        type: "FeatureCollection",
        features: filteredFeatures
      };
      
      console.log('Filtrelenmiş park sayısı:', filteredData.features.length);
      
      // TÜM mevcut layer ve source'ları temizle
      console.log('Temizleme başlıyor...');
      
      const style = map.current.getStyle();
      const allLayers = [...style.layers];
      
      // TÜM layerları kaldır (öncekiler dahil)
      allLayers.forEach(layer => {
        try {
          if (layer.id && (layer.id.includes('-text') || layer.id.includes('parks') || layer.id.includes('layer'))) {
            if (map.current.getLayer(layer.id)) {
              map.current.removeLayer(layer.id);
            }
          }
        } catch (e) {
          // Layer yoksa devam et
        }
      });
      
      // TÜM source'ları kaldır
      const currentStyle = map.current.getStyle();
      if (currentStyle && currentStyle.sources) {
        Object.keys(currentStyle.sources).forEach(sourceId => {
          try {
            // UUID pattern (parks ile ilgili tüm source'ları kaldır)
            if (/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(sourceId) ||
                sourceId.includes('park')) {
              if (map.current.getSource(sourceId)) {
                map.current.removeSource(sourceId);
              }
            }
          } catch (e) {
            // Source yoksa devam et
          }
        });
      }
      
      // Temizleme tamamlansın
      await new Promise(resolve => setTimeout(resolve, 200));
      
      console.log('Temizleme tamamlandi');
      
      // Filtrelenmiş parkları 2D olarak göster (fill-extrusion ile çok küçük yükseklik)
      if (filteredData.features.length > 0) {
        // Z koordinatlarını temizle
        const cleanData = {
          type: "FeatureCollection",
          features: filteredData.features.map(feature => ({
            ...feature,
            geometry: {
              ...feature.geometry,
              coordinates: feature.geometry.coordinates.map(ring => 
                ring.map(coord => [coord[0], coord[1]])
              )
            }
          }))
        };
        
        // 2D görünüm için fill-extrusion kullan (0.1m yükseklik)
        addLocalData(cleanData, "parks-3d", {
          'fill-extrusion-color': '#27ae60',
          'fill-extrusion-opacity': 0.85,
          'fill-extrusion-height': 0.1,
          'fill-extrusion-base': 0
        });
        
        // Park isimlerini göster
        const textSourceId = uuidv4();
        const textSourceInstance = geojsonSource(cleanData);
        map.current.addSource(textSourceId, textSourceInstance);
        
        map.current.addLayer({
          id: textSourceId + "-text",
          type: "symbol",
          source: textSourceId,
          layout: {
            'text-field': ['get', 'MAHAL ADI'],
            'text-font': ['Open Sans Bold', 'Arial Unicode MS Bold'],
            'text-size': [
              'interpolate',
              ['linear'],
              ['zoom'],
              10, 8,   // Zoom 10'da boyut 8
              12, 10,  // Zoom 12'de boyut 10
              14, 13,  // Zoom 14'de boyut 13
              16, 16   // Zoom 16'da boyut 16
            ],
            'text-anchor': 'center',
            'text-allow-overlap': false,  // Overlap'i false yaptık
            'text-ignore-placement': false, // Placement'ı dikkate al
            'text-optional': true  // Gerekirse text gizlenecek
          },
          paint: {
            'text-color': '#000000',
            'text-halo-color': '#FFFFFF',
            'text-halo-width': 2.5,
            'text-halo-blur': 1
          }
        });
        
        // Haritayı parkların merkezine zoom yap
        const bounds = new maplibregl.LngLatBounds();
        cleanData.features.forEach(feature => {
          if (feature.geometry.type === 'Polygon') {
            feature.geometry.coordinates[0].forEach(coord => {
              bounds.extend([coord[0], coord[1]]);
            });
          }
        });
        
        map.current.fitBounds(bounds, {
          padding: 50,
          duration: 1500
        });
      } else {
        console.log('Bu bölgede park bulunamadı');
        alert('Seçilen bölgede park bulunamadı.');
      }
    } catch (error) {
      console.error("Bölgesel filtreleme hatası:", error);
      alert('Bölgesel arama sırasında hata oluştu: ' + error.message);
    }
  };

  return (
    <Fragment>
      <div id="map" style={{ width: "100%", height: "100%" }}></div>
      <StyleChanger changeStyle={changeStyleHandler}></StyleChanger>
      <ExamplesMenu 
        onExampleSelect={handleExampleSelect}
        activeExample={activeExample}
        isOpen={isGisMenuOpen}
        onToggle={(isOpen) => {
          setIsGisMenuOpen(isOpen);
          if (isOpen) setIsRegionalMenuOpen(false);
        }}
      />
      <RegionalSearch 
        onRegionSelect={handleRegionSelect}
        activeRegion={activeRegion}
        isOpen={isRegionalMenuOpen}
        onToggle={(isOpen) => {
          setIsRegionalMenuOpen(isOpen);
          if (isOpen) setIsGisMenuOpen(false);
        }}
      />
      <LayerControls 
        showLabels={showLabels}
        showShapes={showShapes}
        onToggleLabels={onToggleLabels}
        onToggleShapes={onToggleShapes}
      />
      <ImageOverlay mapInstance={map.current} />
      {/* Alt Navigasyon Menüsü */}
      <div style={{
        position: 'fixed',
        bottom: '20px',
        left: '50%',
        transform: 'translateX(-50%)',
        display: 'flex',
        background: 'rgba(44, 62, 80, 0.95)',
        backdropFilter: 'blur(10px)',
        padding: '12px 20px',
        gap: '10px',
        flexWrap: 'wrap',
        alignItems: 'center',
        borderRadius: '12px',
        boxShadow: '0 4px 16px rgba(0, 0, 0, 0.3)',
        zIndex: 10000,
        maxWidth: '90%'
      }}>
        <button 
          onClick={() => navigate('/')}
          style={{
            padding: '10px 20px',
            backgroundColor: '#34495e',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            fontSize: '14px',
            transition: 'background-color 0.3s',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}
          onMouseEnter={(e) => e.target.style.backgroundColor = '#4a5f7a'}
          onMouseLeave={(e) => e.target.style.backgroundColor = '#34495e'}
        >
          🏠 Ana Sayfa
        </button>
        <button 
          onClick={() => navigate('/kmz')}
          style={{
            padding: '10px 20px',
            backgroundColor: '#34495e',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            fontSize: '14px',
            transition: 'background-color 0.3s',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}
          onMouseEnter={(e) => e.target.style.backgroundColor = '#4a5f7a'}
          onMouseLeave={(e) => e.target.style.backgroundColor = '#34495e'}
        >
          📍 KMZ Viewer
        </button>
        <button 
          onClick={() => navigate('/kmz-google')}
          style={{
            padding: '10px 20px',
            backgroundColor: '#34495e',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            fontSize: '14px',
            transition: 'background-color 0.3s',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}
          onMouseEnter={(e) => e.target.style.backgroundColor = '#4a5f7a'}
          onMouseLeave={(e) => e.target.style.backgroundColor = '#34495e'}
        >
          🗺️ Google API ile
        </button>
        <button 
          onClick={() => navigate('/test')}
          style={{
            padding: '10px 20px',
            backgroundColor: '#34495e',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            fontSize: '14px',
            transition: 'background-color 0.3s',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}
          onMouseEnter={(e) => e.target.style.backgroundColor = '#4a5f7a'}
          onMouseLeave={(e) => e.target.style.backgroundColor = '#34495e'}
        >
          🧪 Test Sayfası
        </button>
      </div>
    </Fragment>
  );
};
export default Map;
